import React, { Component } from "react";
import DashSearchHeader from "../../part/header.search.dashboard";
import TutorDashMenu from "../../part/tutor_dash_menu";
import FilterCourse from "../../part/filter_bar_course";
import AddExam from "../../part/add.exam";


class TutorCertificate extends Component {
    state = {
        menuCoverWidth: this.getInitialMenuCoverWidth(),
        windowHeight: window.innerHeight - 60,

    }

    getInitialMenuCoverWidth() {
        const windowWidth = window.innerWidth;
        if (windowWidth < 900) {
            return 0;
        } else if (windowWidth >= 900 && windowWidth < 1200) {
            return 60;
        } else {
            return 260;
        }
    }


    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
        // document.addEventListener('mousedown', this.handleOutsideClick);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
        // document.removeEventListener('mousedown', this.handleOutsideClick);
    }
    handleResize = () => {
        const menuCover = document.querySelector('.dashboard .menu_cover');
        if (menuCover) {
            this.setState({ menuCoverWidth: menuCover.offsetWidth });
        }
        this.setState({ windowHeight: window.innerHeight - 60 });
    };


    handleDisplayExamForm = () =>{
        const formdisplay = document.querySelector(".dash_add_course_cover.addexam")
        formdisplay.style.display = "flex"
    }

    render() {
        const { menuCoverWidth } = this.state;
        return (
            <div className="dashboard">
                <DashSearchHeader onResize={this.handleResize} />
                <TutorDashMenu />
                <div className="dash_body tutor" style={{ width: `calc(100% - ${menuCoverWidth}px - 8px)`, overflowX: "hidden" }} >
                    <div className="dash_container">
                        <div className="dash_head">
                            <h2>Exam & Certificate <button onClick={this.handleDisplayExamForm}>Create Exam</button></h2>
                            <FilterCourse />
                        </div>
                        <div className="dash_body">
                            <div className="container">
                                <h3>GIS Exams</h3>
                                <div className="cover">
                                    <section className="container">
                                        <div className="image"></div>
                                        <div className="content">
                                            <h4><div className="label"><span>GIS - Beginner to Advance</span> <span>Online</span></div>
                                            GIS analysis and Geospatial information gathering </h4>

                                        </div>
                                    </section>
                                </div>
                            </div>
                        </div>

                        <div className="dash_body">
                            <div className="container">
                                <h3>Drone Exams</h3>
                                <div className="cover">
                                    <section className="container">
                                        <div className="image"></div>
                                        <div className="content">
                                            <h4><div className="label"><span>GIS - Beginner to Advance</span> <span>Online</span></div>
                                            GIS analysis and Geospatial information gathering </h4>

                                        </div>
                                    </section>
                                </div>
                            </div>
                        </div>

                        <div className="dash_body">
                            <div className="container">
                                <h3>Survey Exams</h3>
                                <div className="cover">
                                    <section className="container">
                                        <div className="image"></div>
                                        <div className="content">
                                            <h4><div className="label"><span>GIS - Beginner to Advance</span> <span>Online</span></div>
                                            GIS analysis and Geospatial information gathering </h4>

                                        </div>
                                    </section>
                                </div>
                            </div>
                        </div>
                    </div>
                     <AddExam />
                </div>
               
            </div>
        )
    }
}



export default TutorCertificate